import React from 'react';

interface IAboutProps {
  desc: string[]
}

const AboutTab: React.FC<IAboutProps> = (props: IAboutProps) => {
  const { desc } = props;

  return (
    <div className='bite-u-tab-cont'>
      <h1>Course Description</h1>
      {desc.map((d: string, i: number) => (
        <p key={i}>{d}<br /></p>
      ))}
    </div>
  );
};

export default AboutTab;
